export default __webpack_public_path__ + "static/media/GCED_mockup.ea3fb600.png";